import React from 'react'

function ProgressBar(props) {
  console.log("props ",props)
   
  return (
    <div className='w-full  px-8 py-6 mx-auto flex flex-col justify-center relative z-[999]'>

<button
        onClick={props.onCancel}
        className="absolute top-2 right-2 bg-[#ffffff] rounded-full w-8 h-8   text-xl font-bold hover:text-red-500"
        title="Cancel upload"
      >
        ×
      </button>
 
<div className=" flex  justify-between mb-1"> 
  
  <span className="text-base mt-3 font-medium text-white dark:text-white">File: {props.fileName}</span>
   <span className="text-base mt-3 font-medium text-white dark:text-white"> {props.txt}</span>
 
</div>
<div className="w-full bg-gray-800 rounded-full h-2.5 ">
<div className="bg-gray-400 h-2.5 rounded-full" style={{ width: `${props.prgBarVal}%` }}></div>
<span className="text-sm font-medium text-white dark:text-white">{props.prgBarVal}%</span>


</div>
    </div>
  )
}

export default ProgressBar